import React, { useState } from 'react';

const PlanList = ({ plans = [], onEdit }) => {
  const [search, setSearch] = useState('');

  const filteredPlans = plans.filter((p) =>
    p.plan?.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-5xl bg-white rounded shadow p-6 mx-auto mt-6">
      <h2 className="text-xl font-semibold mb-4">Plans</h2>

      <input
        type="text"
        placeholder="Search plans..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full px-4 py-2 border rounded mb-4"
      />

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 text-left">Plan Name</th>
            <th className="p-2 text-left">Price</th>
            <th className="p-2 text-left">Days</th>
            <th className="p-2 text-left">Type</th>
          </tr>
        </thead>
        <tbody>
          {filteredPlans.length === 0 ? (
            <tr><td colSpan="4" className="text-center p-4 text-gray-500">No plans found</td></tr>
          ) : (
            filteredPlans.map((p) => (
              <tr
                key={p.id}
                onClick={() => onEdit?.(p)}
                className="cursor-pointer hover:bg-gray-50 border-t"
              >
                <td className="p-2">{p.plan?.name || '—'}</td>
                <td className="p-2">{p.price}</td>
                <td className="p-2">{p.days}</td>
                <td className="p-2">{p.monthlyYearly || '—'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PlanList;
